// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2JO1g","title":"ClientReferral_title__2YuTG","itemText":"ClientReferral_itemText__28VOO"};